export default __webpack_public_path__ + "static/media/f7.5cc4f1fe.jpg";